import {
  FETCH_OEM_VENDOR,
  FETCH_OEM_VENDOR_SUCCESS,
  FETCH_OEM_VENDOR_FAIL,
  GET_OEM_VENDOR,
  GET_OEM_VENDOR_SUCCESS,
  GET_OEM_VENDOR_FAIL,
  CREATE_OEM_VENDOR,
  CREATE_OEM_VENDOR_SUCCESS,
  CREATE_OEM_VENDOR_FAIL,
  UPDATE_OEM_VENDOR,
  UPDATE_OEM_VENDOR_SUCCESS,
  UPDATE_OEM_VENDOR_FAIL,
  DELETE_OEM_VENDOR,
  DELETE_OEM_VENDOR_SUCCESS,
  DELETE_OEM_VENDOR_FAIL,
} from 'actions/oemVendor';
import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';

function* fetchOemVendor(action) {
  try {
    const response = yield call(API.getOemVendor, action.payload);
    yield put({ type: FETCH_OEM_VENDOR_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_OEM_VENDOR_FAIL, payload: { error: e } });
  }
}

function* getOemVendorById(action) {
  try {
    const response = yield call(API.getOemVendorById, action.payload);
    yield put({ type: GET_OEM_VENDOR_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_OEM_VENDOR_FAIL, payload: { error: e } });
  }
}

function* createOemVendor(action) {
  try {
    const response = yield call(API.addOemVendor, action.payload);
    yield put({ type: CREATE_OEM_VENDOR_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_OEM_VENDOR_FAIL, payload: { error: e } });
  }
}

function* updateOemVendor(action) {
  try {
    const response = yield call(API.updateOemVendor, action.payload);
    yield put({ type: UPDATE_OEM_VENDOR_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_OEM_VENDOR_FAIL, payload: { error: e } });
  }
}

function* deleteOemVendor(action) {
  try {
    const response = yield call(API.deleteOemVendor, action.payload);
    yield put({ type: DELETE_OEM_VENDOR_SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_OEM_VENDOR_FAIL, payload: { error: e } });
  }
}

function* oemVendor() {
  yield takeLatest(FETCH_OEM_VENDOR, fetchOemVendor);
  yield takeLatest(GET_OEM_VENDOR, getOemVendorById);
  yield takeLatest(CREATE_OEM_VENDOR, createOemVendor);
  yield takeLatest(UPDATE_OEM_VENDOR, updateOemVendor);
  yield takeLatest(DELETE_OEM_VENDOR, deleteOemVendor);
}

export default oemVendor;
